var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66406 20.3395C3.66406 16.5255 3.66406 14.6185 4.5294 13.0376C5.39473 11.4567 6.97564 10.4755 10.1375 8.51322L13.4708 6.44446C16.813 4.37016 18.4842 3.33301 20.3307 3.33301C22.1773 3.33301 23.8484 4.37016 27.1907 6.44446L30.524 8.51322C33.6858 10.4755 35.2667 11.4567 36.1321 13.0376C36.9974 14.6185 36.9974 16.5255 36.9974 20.3395V22.8746C36.9974 29.3761 36.9974 32.6268 35.0448 34.6466C33.0922 36.6663 29.9495 36.6663 23.6641 36.6663H16.9974C10.712 36.6663 7.56931 36.6663 5.61668 34.6466C3.66406 32.6268 3.66406 29.3761 3.66406 22.8746V20.3395Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeW);
export default __webpack_public_path__ + "static/media/Home-w.b38034d16de2d51dbb3934016849deee.svg";
export { ForwardRef as ReactComponent };